import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class CustomerService {
    private endpointPrefix = environment.apiUrl;
    constructor(private http: HttpClient) { }

    private selectedCustomerSubject = new BehaviorSubject<any>(null);
    selectedCustomer$ = this.selectedCustomerSubject.asObservable();

    private isJubooAgentSubject = new BehaviorSubject<boolean>(false);
    isJubooAgent$ = this.isJubooAgentSubject.asObservable();


    setCustomer(customer: any) {
        this.selectedCustomerSubject.next(customer);
    }

    getCustomer() {
        return this.selectedCustomerSubject.value;
    }

    setIsJubooAgent(isAgent: boolean) {
        this.isJubooAgentSubject.next(isAgent);
    }

    getIsJubooAgent() {
        return this.isJubooAgentSubject.value;
    }

    getCustomerById(customerId: number): Observable<any> {
        return this.http.get<any>(`${this.endpointPrefix}/customers/${customerId}`);
    }

    getCustomers(): Observable<any[]> {
        return this.http.get<any[]>(`${this.endpointPrefix}/customers`);
    }

    getConfigurationDataByCustomer(customerId: number, type: string) {
        return this.http.get<any>(`${this.endpointPrefix}/customers/${customerId}/configuration-data?type=${type}`);
    }
}
